var React = require('react');

function RectangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.601 27L0 8.399 8.401 0 27 18.6z"}));
}

RectangleInline.defaultProps = {"viewBox":"0 0 27 27","fill":"#7FCACA"};

module.exports = RectangleInline;

RectangleInline.default = RectangleInline;
